import React, { JSX, useContext } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { BenchmarkingFiltersContext } from "@app/overviews/network-benchmarking-dashboard/filters/BenchmarkingFiltersContext";
import { CompetitiveInsightsMap } from "@app/overviews/network-benchmarking-dashboard/filters/CompetitiveInsightsMap";
import { CompetitiveInsightsViewTypeEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared";
import { QHPFiltersContext } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/QHPFiltersContext";
import QHPNetworkFilters from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/QHPNetworkFilters";
import QHPPrimaryFilters from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/QHPPrimaryFilters";

interface QHPFiltersProps {
  isRedesign?: boolean;
  selectedView: CompetitiveInsightsViewTypeEnum;
}

const QHPFilters = (props: QHPFiltersProps): JSX.Element => {
  const benchmarkingFiltersContext = useContext(BenchmarkingFiltersContext);
  const qhpFiltersContext = useContext(QHPFiltersContext);

  return (
    <React.Fragment>
      {!benchmarkingFiltersContext.displayedPrimaryFilters && (
        <div className="row">
          <div className="col-12">
            <label className="copy-text-default mb-3">
              Please begin by selecting and applying your filters to view available networks for comparison.
            </label>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className={!props.isRedesign ? "card card-static" : ""}>
            <div className={!props.isRedesign ? "card-body" : ""}>
              <QHPPrimaryFilters />

              {(!qhpFiltersContext.primaryFiltersLoading && !!benchmarkingFiltersContext.states?.length) ? (
                props.selectedView === CompetitiveInsightsViewTypeEnum.MapView ? (
                  <CompetitiveInsightsMap
                    networkFiltersLoading={qhpFiltersContext.networkFiltersLoading}
                    parentOrganizations={qhpFiltersContext.parentOrganizations}
                    selectedNetworkCount={benchmarkingFiltersContext.selectedNetworks?.length}
                    showNetworks={!!benchmarkingFiltersContext.displayedPrimaryFilters}
                  />
                ) : (
                  !!benchmarkingFiltersContext.displayedPrimaryFilters && (
                    <QHPNetworkFilters />
                  )
                )
              ) : (
                <div className="text-center">
                  <LoadingSpinner />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default QHPFilters;